<template>
<Modal 
    :id="'cmp_import_match_split_statement_income'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
        <template>  </template>
        
    </template>
    <template slot="body">
        <div>
          <p> {{$t('split_stmt_1')}}  </p>
          <p> {{$t('split_stmt_2')}}  </p>
          <p style="font-weight:800"> {{`${statement_import_info.account_name} - ${statement.statement_year} ${statement.statement_period_txt} - ${statement_import_info.description} (unmatched) ` }}  </p>
          <p> {{`${$dft.capHead($t('lines'))} : ${unmatch_lines}` }}  </p>
          <p> {{`${$t(turnoverText)} : ${unmatch_turnover}`}}  </p>
        </div>

     </template>
    <template slot="options">
      
        <button  class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
        <button class="dt-button s7 v1" @click="onOKClicked">{{ $t('ok') }}</button>
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";


import ModalContainer from "@dtplugins/modal/modal-container";
import { DistributionStatementService } from '../../services/statement.service';




export default {
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
   
    //AdvanceSearch,
   
  },
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  mounted:async  function () {
    const res =  await DistributionStatementService.splitMatchUnmatchInfo(this.statement_id);
    this.modalInitData = res.data;
    this.statementInit = res.data.statement;
    this.unmatch_turnover = res.data.unmatch_turnover;
    this.unmatch_lines =res.data.unmatch_lines;
    console.log("RES::::::::",res)
  },
  data: function () {
    return {
      
      modalInitData :{},
      statementInit:{},
      unmatch_lines:undefined,
      unmatch_turnover:undefined,
      min_income:0,
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },
    
    };
  },
   mixins: [],

  computed: {
    minIncome:function(){
      return `${this.min_income} EUR`
    },
    statement_id: function () {
      return this.$route.params.statement_id;
    },
    statement_import_info:function () {
      return this.selectedStatementDetails.statement_import_info;
    },
    statement:function(){
       return this.selectedStatementDetails.statement;
    },
    currentChannel:function(){
      return this.selectedStatementDetails?.statement?.digital_physical||'';
    },
    turnoverText:function(){
      return (this.currentChannel=='costs'||this.currentChannel=='income')?'cost':'turnover'
    }

    
  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

    onOKClicked:function(){
       this.$emit("change", {menu:'split_statement',statement_id:this.statement_id , min_income:this.min_income });
    },



    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      key=value
    },
  
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>